import { ObjectGraph } from '@jet/environment/dependencies/object-graph';
import { Bag } from '../dependencies/bag';
import { Features } from '../dependencies/features';

interface Parameters {
    [key: string]: string;
}

export class ClassicalAPIURLQueryString {
    shouldIncludeLanguage = true;
    shouldIncludePlatform = true;
    parameters: Parameters = {};

    private readonly _objectGraph: ObjectGraph;

    constructor(objectGraph: ObjectGraph) {
        this._objectGraph = objectGraph;
    }

    get encodedString(): string {
        const parameters = this.object();

        return Object.entries(parameters)
            .sort()
            .map(
                ([key, value]) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
            )
            .join('&');
    }

    addParameters(parameters: Parameters): void {
        Object.assign(this.parameters, parameters);
    }

    private object(): Parameters {
        const parameters = { ...this.parameters };

        if (this.shouldIncludeLanguage) {
            parameters.l = Bag.languageTag(this._objectGraph);
        }

        if (this.shouldIncludePlatform) {
            parameters.platform = 'web';
        }

        // TODO: rdar://152085409 ([Classical on Web] - Remove Motion query param)
        // TODO: rdar://157050466 ([Classical on Web]: Editorial Stations - Remove Feature Flag)
        // TODO: rdar://155630358 ([Classical on Web] - Super Rooms - Remove feature flag)
        const clfeValues = ['uh', 'stns', 'mr'];

        parameters.clfe = clfeValues.join(',');

        return parameters;
    }
}
